  import { BrowserModule } from "@angular/platform-browser";
  import { NgModule } from "@angular/core";
  import { HttpModule } from "@angular/http";
  import { FormsModule } from "@angular/forms";
  import { Router, RouterModule } from "@angular/router";
  import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
  import { ToastrModule, ToastrService } from "ngx-toastr";
  import { CoreModule } from "@app/components/core/core.module";
  import { AppComponent } from "@app/app.component";
  import { ChangePasswordComponent } from "@app/components/customer-login/change-password.component";
  import { LoginComponent } from "@app/components/customer-login/login.component";
  import { AuthenticationService } from "@app/services/authentication/authentication.service";
  import { AuthenticationEndpoint } from "@app/services/authentication/authentication-endpoints.service";
  import { ForgetPasswordComponent } from "@app/components/customer-login/forgot-password/forgetpassword.component";
  import { ChangePassService } from "@app/services/authentication/change-pass.service";
  import { ChangePassEndpoint } from "@app/services/authentication/change-pass-endpoints.service";
  import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
  import { TokenInterceptor } from "@app/services/base-service/tokenInterceptor.service";
  import { MainRoutingModule } from "@app/app.routes";
  import { NotFoundComponent } from "@app/components/common/not-found/not-found.component";
  import { SelectRequiredValidatorDirective } from "@app/directives/select-required-validator.directive";
  import { ValueTypedEndPoint } from "@app/services/valueType/valueType-endpoint.service";
  import { ValueTypeService } from "@app/services/valueType/valuetype.service";
  import { ForgotPasswordEndpoint } from "@app/services/authentication/forgotPassword-endpoint.service";
  import { ForgotPasswordService } from "@app/services/authentication/forgotPassword.service";
  import { LoaderComponent } from "@app/components/common/loader/loader.component";
  import { LoaderService } from "@app/services/shared/loader.service";
  import { CustomerService } from "@app/services/customer-registration/customer.service";
  import { CustomerEndpoint } from "@app/services/customer-registration/customer-endpoint.service";
  //import { RetailCustomerRegisterComponent } from '@app/components/customer-registration/retail-customer-register.component';
  import { SharedModule } from "@app/components/core/shared.module";
  //import { FleetCustomerRegistrationComponent } from '@app/components/customer-registration/fleet-customer-register.component';
  import { CustomerPreloginComponent } from "@app/components/customer-pre-login/pre-login.component";
  import { FAQComponent } from "@app/components/customer-pre-login/faq/faq.component";
  import { TermsAndConditionsComponent } from "@app/components/customer-pre-login/termsandconditions/termsandconditions.component";
  import { SlideshowModule } from "ng-simple-slideshow";
  import { PreLoginHeaderComponent } from "@app/components/customer-pre-login/pre-login-header/pre-login-header.component";
  import { PreLoginFooterComponent } from "@app/components/customer-pre-login/pre-login-footer/pre-login-footer.component";
  import { ResetPasswordComponent } from "@app/components/customer-login/resetPassword.component";
  import { CustomerPreloginDefaultComponent } from "@app/components/customer-pre-login/pre-login-default.component";
  import { OutletsComponent } from "@app/components/customer-pre-login/outlets/outlets.component";
  import { WalletAggregatorComponent } from "./components/customer-pre-login/wallet-aggregator/wallet-aggregator.component";
  import { LoyaltyManagementComponent } from "./components/customer-pre-login/loyalty-management/loyalty-management.component";
  import { OfferAndCouponManagementComponent } from "./components/customer-pre-login/offer-and-coupon-management/offer-and-coupon-management.component";
  import { MobileForceComponent } from "./components/customer-pre-login/mobile-force/mobile-force.component";
  import { PrepaidComponent } from "./components/customer-pre-login/prepaid/prepaid.component";
  import { MenuserviceService } from "./common/menuservice.service";
  import { CardNumberPipe } from "./common/card-number.pipe";
  import { SharedService } from "./services/SharedService/cheque.service";
  import { UnlockUserService } from "./services/authentication/unlock-user.service";
import { PrivacyPolicyComponent } from "./components/customer-pre-login/privacy-policy/privacy-policy.component";

  @NgModule({
    declarations: [
      AppComponent,
      ChangePasswordComponent,
      LoginComponent,
      NotFoundComponent,
      SelectRequiredValidatorDirective,
      ForgetPasswordComponent,
      //ForgetPasswordComponent,
      //OldPasswordValidatorDirective,
      //ConfirmEqualValidatorDirective,
      LoaderComponent,
      //FleetCustomerRegistrationComponent,
      //RetailCustomerRegisterComponent,
      CustomerPreloginComponent,
      FAQComponent,
      TermsAndConditionsComponent,
      PreLoginHeaderComponent,
      PreLoginFooterComponent,
      ResetPasswordComponent,
      CustomerPreloginDefaultComponent,
      OutletsComponent,
      WalletAggregatorComponent,
      LoyaltyManagementComponent,
      OfferAndCouponManagementComponent,
      MobileForceComponent,
      PrepaidComponent,
      CardNumberPipe,
      PrivacyPolicyComponent,   
    ],
    imports: [
      BrowserModule,
      HttpModule,
      FormsModule,
      SharedModule,
      HttpClientModule,
      MainRoutingModule,
      CoreModule,
      RouterModule,
      BrowserAnimationsModule,
      //SlideshowModule,
      ToastrModule.forRoot({
        timeOut: 10000,
        positionClass: "toast-top-right",
        preventDuplicates: true,
      }),
    ],
    //exports:[SlideshowModule],
    providers: [
      {
        provide: HTTP_INTERCEPTORS,
        useClass: TokenInterceptor,
        multi: true,
      },
      ToastrService,
      ChangePassService,
      ChangePassEndpoint,
      HttpClientModule,
      ValueTypedEndPoint,
      ValueTypeService,
      ToastrService,
      AuthenticationService,
      AuthenticationEndpoint,
      ForgotPasswordEndpoint,
      ForgotPasswordService,
      LoaderService,
      CustomerService,
      CustomerEndpoint,
      MenuserviceService,
      SharedService,
      UnlockUserService,
    ],
    bootstrap: [AppComponent],
  })
  export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts